<template>
	<TwoColumns
		columns-order="flex-col lg:flex-row"
		first-column-class="items-center flex"
		second-column-class="contained-section"
	>
		<template #first>
			<CarbarImage
				image="img/car-subscription/img-eligible.webp"
				alt-text="Check if you are eligible"
			/>
		</template>
		<template #second>
			<div class="flex w-full flex-col items-center">
				<h2>
					How do I know if I’m eligible for a carbar car subscription?
				</h2>
				<div class="space-y-5">
					<p>
						All drivers must be over 21 years old and hold a P2 or
						higher Driver Licence.
					</p>
					<p>
						To be approved for a car subscription, we ask for the
						following standard documents to run an affordability and
						ID check. Please note this is not a credit check and
						will not show on your credit rating.
					</p>
					<div>
						<TickList
							:items="items"
							:columns-count="1"
							class="space-y-2 text-lg"
						></TickList>
					</div>
				</div>
			</div>
			<div class="mt-8">
				<CarbarButton
					v-if="!isListingOnly"
					is-silent-filter
					:is-full-width="false"
					@click="scrollTo('#start-subscription-journey')"
				>
					Start your subscription journey here
				</CarbarButton>
			</div>
			<div class="mt-8">
				<TermsAndConditions :is-full-width="false">
					<CarbarLink
						:href="'/terms-and-conditions/car-subscription'"
						target="_blank"
						text="Terms and conditions"
						class="text-xsm"
					/>
					apply.
				</TermsAndConditions>
			</div>
		</template>
	</TwoColumns>
</template>

<script setup>
import TwoColumns from '@/components/sections/TwoColumns.vue'
import CarbarImage from '@/components/CarbarImage.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import TickList from '@/components/lists/TickList.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'

const items = [
	{
		label: 'Australian Driver Licence or International Driver Licence',
	},
	{
		label: 'Australian Medicare card or Australian Passport or International Passport',
	},
	{
		label: 'Evidence of residential address',
	},
	{
		label: 'Last 3 months banks statements showing proof of income',
	},
	{
		label: 'Completed driver declaration',
	},
	{
		label: 'Valid credit card to pay the upfront fee',
	},
]

const isListingOnly = useIsListingOnly()
</script>
